import type { TableColumns } from '@ohpen/enso-ui';
import type { GroupedExchangeRateResponse, RateEntry } from '@pmp/api';

export const exchangeRateColumns: TableColumns<GroupedExchangeRateResponse> = [
  {
    title: 'pmp.exchangeRates.labels.sourceCurrency',
    dataIndex: 'sourceCurrency',
    key: 'sourceCurrency',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.targetCurrency',
    dataIndex: 'targetCurrency',
    key: 'targetCurrency',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.description',
    dataIndex: 'description',
    key: 'description',
    width: 150,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.abbreviation',
    dataIndex: 'abbreviation',
    key: 'abbreviation',
    width: 90,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.symbol',
    dataIndex: 'symbol',
    key: 'symbol',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.rate',
    dataIndex: 'rate',
    key: 'rate',
    options: {
      format: {
        type: 'number',
      },
      filter: 'number',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    options: {
      filter: 'date',
      sorter: true,
      hide: true,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const historicColumns: TableColumns<RateEntry> = [
  {
    title: 'pmp.exchangeRates.labels.rate',
    dataIndex: 'rate',
    key: 'rate',
    options: {
      format: {
        type: 'number',
      },
      filter: 'number',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const exchangeRateChangeColumns: TableColumns<GroupedExchangeRateResponse> = [
  {
    title: 'pmp.exchangeRates.labels.sourceCurrency',
    dataIndex: 'sourceCurrency',
    key: 'sourceCurrency',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.targetCurrency',
    dataIndex: 'targetCurrency',
    key: 'targetCurrency',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.rate',
    dataIndex: 'rate',
    key: 'rate',
    options: {
      format: {
        type: 'number'
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.exchangeRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
];

export const exchangeRateExportColumns: TableColumns<GroupedExchangeRateResponse & { endDate: string }> = [
  {
    title: 'pmp.exchangeRates.labels.sourceCurrency',
    dataIndex: 'sourceCurrency',
    key: 'sourceCurrency',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.targetCurrency',
    dataIndex: 'targetCurrency',
    key: 'targetCurrency',
    width: 120,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.rate',
    dataIndex: 'rate',
    key: 'rate',
    options: {
      format: {
        type: 'number',
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.exchangeRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.exchangeRates.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
];
